export default {
  layout: '_base'
};